import React from "react"
import { Link, Box, Flex } from "theme-ui"
import { Link as GatsbyLink } from "gatsby"
import { globalHistory } from "@reach/router"

const breadcrumbRoutes = ["guides", "recipes"]

export const Breadcrumbs = ({ title }) => {
  const { location } = globalHistory
  const [, base, path] = location.pathname.split("/")
  if (!breadcrumbRoutes.includes(base)) return false
  if (!path) return false

  return (
    <Flex
      sx={{
        fontWeight: "bold",
        mb: 4,
        textTransform: "capitalize",
      }}
    >
      <Link as={GatsbyLink} to={"/" + base}>
        {base}
      </Link>
      <Box px={2}>/</Box>
      <Box>{title || path}</Box>
    </Flex>
  )
}

export const wrapper = ({ title, description, image, ...props }) => {
  const children = React.Children.toArray(props.children).reduce(
    (acc, child, index) => {
      const type = child.props?.mdxType
      if (type !== "h1") return [...acc, child]
      return [
        ...acc,
        child,
        <Breadcrumbs key={`breadcrumbs-${index}`} title={title} />,
      ]
    },
    []
  )

  return children
}
